import React, { useEffect, useState}  from 'react';
import { Box, Button, Typography } from '@mui/material';
import DataTableMD from '../core/dataTableMD';
import { useLocation, useNavigate } from 'react-router-dom';
import { presetFromState } from './configs/incidentPresets';
import { incidentsColumns, getIncidentsFilters, incidentsToggles } from './configs/incidentsDataTableConfig';

/*
 * This generates the Incidents Page for the application
 * @param {*} props These are the properties required for the Incidents page (user, etc)
 * @returns This returns a generated Incidents page for the user
 */


const IncidentsPage = (props) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    // Opened from a dashboard tile (e.g. "Active emergencies"): start pre-filtered.
    const preset = presetFromState(state);
    const [filters, setFilters] = useState([])
    useEffect(() => {
        const getFilters = async () => {
            const filters = await getIncidentsFilters(state)
            setFilters(filters)
        }
        getFilters()
        // eslint-disable-next-line
    }, [])
    return (
        <>
        {preset && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '16px 16px 0' }}>
                <Typography sx={{ fontSize: '15px' }}>
                    Showing: <strong>{preset.label}</strong> (from the dashboard)
                </Typography>
                <Button size="small" variant="outlined" sx={{ textTransform: 'none' }}
                    onClick={() => navigate('/incidents', { replace: true, state: null })}>
                    Show all incidents
                </Button>
            </Box>
        )}
        <DataTableMD
            key={preset ? preset.label : 'all'}
            initialFilters={preset ? preset.filters : undefined}
            initialToggle={preset ? preset.toggle : undefined}
            title="Incidents"
            dbTable={"incidents"}
            filters = {filters}
            toggles = {incidentsToggles} // or null for none
            columns = {incidentsColumns}
            sort={{field: 'dateCreated', order: 'desc'}}
        />
        </>
    );
};

export default IncidentsPage;